/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Type_NameInputs */

const en_task_catalog_type_name = /** @type {(inputs: Task_Catalog_Type_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const pt_br2_task_catalog_type_name = /** @type {(inputs: Task_Catalog_Type_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Task_Catalog_Type_NameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_type_name = /** @type {((inputs?: Task_Catalog_Type_NameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Type_NameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_type_name(inputs)
	return pt_br2_task_catalog_type_name(inputs)
});